import Swiper from 'swiper';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';
export default class SealsList {
    constructor() {
        this.sections = document.querySelectorAll('.block-seals-list');
        this.ready();
    }

    ready() {

        if (this.sections.length > 0) {
            this.sections.forEach((section) => {
                this.slider = section.querySelector('.swiper');
                const swiper = new Swiper(this.slider, {
                    modules: [Autoplay],
                    grabCursor: false,
                    allowTouchMove: false,
                    spaceBetween: 28,
                    breakpoints: {
                        0: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                        },
                        1200: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                        }
                    },
                    autoplay: {
                        delay: 3000,             // 3 segundos entre os slides
                        disableOnInteraction: false, // Continua autoplay mesmo se o usuário interagir
                    },
                });

            })
        }

    }
}

if (document.querySelector('.block-seals-list')) {
    new SealsList();
}